import React, { Component } from "react";
import { connect } from "react-redux";
import { showError, showSuccess } from "ReduxErrorBar";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import { deleteCoupon, editCoupon, openTicketModal } from "TicketAction";
import { COMMON_FAIL_MESSAGE } from "Constants";
import LocaleStrings from "Languages";

class CouponListItem extends React.Component {
  constructor(props) {
    super(props);
    this.editCoupon = this.editCoupon.bind(this);
    this.deleteCoupon = this.deleteCoupon.bind(this);
  }

  editCoupon() {
    this.props.editCoupon(this.props.coupon);
    this.props.openTicketModal(true);
  }

  deleteCoupon() {
    confirmAlert({
      title: LocaleStrings.tickets_coupon_title_delete_coupon,
      message: LocaleStrings.tickets_coupon_text_sure_want_to_delete,
      confirmLabel: LocaleStrings.button_ok,
      cancelLabel: LocaleStrings.button_cancel,
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            this.props.deleteCoupon(
              this.props.session,
              this.props.coupon,
              (response) => {
                if (response.success === 0) {
                  this.props.showError(COMMON_FAIL_MESSAGE);
                } else {
                  let cp = this.props.coupon;
                  cp.deleted = true;
                  this.props.showSuccess(
                    LocaleStrings.tickets_coupon_text_delete_coupon_success
                  );
                }
              }
            );
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  }

  render() {
    let { couponCodeUsed } = this.props;

    return (
      <tr>
        <td>
          <div className="vcenter">{this.props.coupon.couponcode}</div>
        </td>
        <td>
          <div className="vcenter">
            {this.props.coupon.coupontype == "percentage"
              ? this.props.coupon.amount + " % off each ticket"
              : this.props.coupon.amount + " off each ticket"}
          </div>
        </td>
        <td>
          <div className="vcenter">{couponCodeUsed}</div>
        </td>
        <td>
          <div className="vcenter">{this.props.coupon.usagelimit}</div>
        </td>
        <td>
          <div className="vcenter text-capitalize">
            {this.props.coupon.status}
          </div>
        </td>
        <td>
          <div className="action-button vcenter">
            <button
              className="btn btn-custom-table-white"
              onClick={this.editCoupon}
            >
              {LocaleStrings.button_edit}
            </button>
          </div>
          {couponCodeUsed == 0 ? (
            <div className="action-button vcenter">
              <button
                className="i-custom-table-delete"
                onClick={this.deleteCoupon}
              >
                <img src="../../style/images/custom-icons/shape-1317-copy-3.svg" />
              </button>
            </div>
          ) : (
            ""
          )}
        </td>
      </tr>
    );
  }
}

export var mapStateToProps = (state) => {
  return {
    session: state.session,
    orderList: state.OrderList,
  };
};

export default connect(mapStateToProps, {
  deleteCoupon,
  editCoupon,
  showError,
  showSuccess,
  openTicketModal,
})(CouponListItem);
